export function debounce<T extends unknown[]>(
  fn: (...args: T) => void,
  ms: number,
) {
  let timeout: ReturnType<typeof setTimeout> | null = null;

  return function (this: unknown, ...args: T) {
    if (timeout) {
      clearTimeout(timeout);
    }
    timeout = setTimeout(() => fn.apply(this, args), ms);
  };
}
